import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import Common from '../common'

export default class CourseConfigurationSettings extends Component {
    render() {
        return <Common.Settings isConfig={true} />
    }
}